






import { Component, Vue } from 'vue-property-decorator'
import GlobalHeader from '@/components/GlobalHeader'
@Component({
  components:{
    GlobalHeader,
  }
})
export default class UserLayout  extends Vue {
}
